var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AddApprentice'),_c('RecruitmentFormApprentice'),_c('Tutor'),_c('ApprenticeTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }